// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b0dc9682","239":"157e19e9","488":"68e38502","664":"562e5a41","732":"47bf8276","977":"da868973"}[chunkId] + ".chunk.js";
};